module.exports = __webpack_public_path__ + "img/img-news-desktop.e140aa3e.png";